import * as yup from 'yup';
import moment, { Moment } from 'moment';

export class MomentSchema extends yup.Schema<Moment> {
    constructor() {
        super({
            type: 'moment',
            check: function (value: unknown): value is moment.Moment {
                return moment.isMoment(value) && value.isValid();
            },
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any).transforms.push(function (this: any, value: any) {
            if (this.isType(value)) {
                return value;
            }
            value = moment(value);
            return value.isValid() ? value : moment.invalid();
        });
    }
}

export const yupCmsHistory = yup.object({
    email: yup.string().required(),
    action: yup.string().required(),
    createdAt: yup.string().required(),
});
